import {
  resetStateToDefault,
  vuexMapDefaultsMutations,
  vuexMapDefaultsActions,
  vuexMapDefaultsGetters
} from 'src/utils'

import { API } from 'src/services'

const moduleGroups = {
  cadastro: [
    'cadastros',
    'company',
    'compemployee',
    'employer',
    'journey',
    'reason',
    'region',
    'role',
    'rolegroup',
    'routine',
    'supervisor',
    'user',
    'usergroup'
  ],
  lancamentos: [
    'abstractjustify',
    'arbitrarytms',
    'holidaysCalendar',
    'justify',
    'sumtimemeasurements',
    'suspension',
    'workhourbankauth'
  ],
  bancoDeHoras: [
    'workhourbankcloser',
    'workhourbankobjects',
    'workhourbankrules',
    'workhourbankwindow'
  ],
  administracao: [
    'appkey',
    'arbitrarytmsrules',
    'customevent',
    'customrules',
    'dayjourney',
    'deviceregister',
    'edittimelogkind',
    'employeemov',
    'employeemovover',
    'exportfiles',
    'faketimelog',
    'groupscomment',
    'ignoretimelog',
    'importafd',
    'manage',
    'nextel',
    'notification',
    'notificationrules',
    'objectapprovalrules',
    'objectapprovalsrequest',
    'positionrule',
    'recalculatekind',
    'showtimelogs',
    'userblock',
    'aprovacaoarquivo'
  ],
  acompanhamento: [
    'absence',
    'autocomplete',
    'autocorrect',
    'biometric',
    'eventlog',
    'fastregister',
    'lineapprovalrequest',
    'lineapprovalsrules',
    'lockconfirmation',
    'locker',
    'movementlog',
    'oncall',
    'problems',
    'realtime',
    'timelog',
    'timemeasurements',
    'unilateralcloses',
    'unlocker',
    'unlockerask'
  ],
  atividades: [
    'activityapprove',
    'activitycostcenter',
    'activityline',
    'activityobject',
    'activitytype'
  ]
}

function fromBackend (roleGroup) {
  return {
    id: roleGroup.id,
    name: roleGroup.name,
    description: roleGroup.description,
    kind: roleGroup.kind,
    roles: roleGroup.roles
  }
}

function toBackEnd (state) {
  function formatRoles (s) {
    const extractRoles = (acc, m) => {
      if (m.actions.get) acc.push({module: m.module, filter: s.kind, action: 'get'})
      if (m.actions.post) acc.push({module: m.module, filter: s.kind, action: 'post'})
      if (m.actions.delete) acc.push({module: m.module, filter: s.kind, action: 'delete'})
      return acc
    }
    const cadastro = s.cadastro.reduce(extractRoles, [])
    const lancamentos = s.lancamentos.reduce(extractRoles, [])
    const bancoDeHoras = s.bancoDeHoras.reduce(extractRoles, [])
    const administracao = s.administracao.reduce(extractRoles, [])
    const acompanhamento = s.acompanhamento.reduce(extractRoles, [])
    const atividades = s.atividades.reduce(extractRoles, [])

    return [
      ...cadastro,
      ...lancamentos,
      ...bancoDeHoras,
      ...administracao,
      ...acompanhamento,
      ...atividades
    ]
  }

  const request = {
    name: state.name,
    description: state.description,
    kind: state.kind,
    roles: formatRoles(state)
  }

  if (state.id) request.id = state.id

  return request
}

function defaultState () {
  return {
    loading: false,
    roleDetails: null,
    options: null,
    cadastro: null,
    lancamentos: null,
    bancoDeHoras: null,
    administracao: null,
    acompanhamento: null,
    atividades: null,

    // object to back end
    id: null,
    name: '',
    description: '',
    kind: 'all'
  }
}

const getters = {
  ...vuexMapDefaultsGetters(defaultState())
}

const mutations = {
  ...vuexMapDefaultsMutations(defaultState()),
  resetState (state) {
    resetStateToDefault(state, defaultState())
  },
  setFromState (state, {...roleGroup}) {
    console.log(roleGroup)
    roleGroup.roles.forEach(r => {
      const group = Object.keys(moduleGroups)
        .filter(m => moduleGroups[m].includes(r.module))
      if (group.length === 1) {
        const groupName = group[0]
        const m = state[groupName].find(m => m.module === r.module)
        m.actions[r.action] = true
      }
    })

    delete roleGroup.roles
    Object.assign(state, roleGroup)
  },
  formatPermissions (state, payload) {
    const objectFormat = m => {
      return {
        module: m,
        moduleName: payload.modulesPrettifier[m],
        actions: {
          get: false,
          post: false,
          delete: false
        },
        kind: 'mine'
      }
    }
    const filterByModule = g => formatedModules.filter(m => moduleGroups[g].includes(m.module))

    const formatedModules = payload.modules.map(objectFormat)
    state.cadastro = filterByModule('cadastro')
    state.lancamentos = filterByModule('lancamentos')
    state.bancoDeHoras = filterByModule('bancoDeHoras')
    state.administracao = filterByModule('administracao')
    state.acompanhamento = filterByModule('acompanhamento')
    state.atividades = filterByModule('atividades')
  },
  loading (state, payload) {
    state.loading = payload
  }
}

const actions = {
  ...vuexMapDefaultsActions(defaultState()),
  async loadRoleGroups ({ commit }, roleGroupId) {
    commit('loading', true)

    const api = await API.roleGroup.get({id: roleGroupId})

    commit('setFromState', {
      ...fromBackend(api.data.success[0])
    })
    commit('loading', false)
  },
  async loadRoleDetails ({ commit }) {
    const api = await API.roleDetails.get()

    commit('roleDetails', api.data.success)
    commit('formatPermissions', api.data.success)
  },
  async save ({ state }) {
    const info = toBackEnd(state)

    // console.log(info)
    if (state.id) {
      await API.roleGroup.save({id: state.id}, info)
    } else {
      await API.roleGroup.save(info)
    }
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations,
  actions
}
